import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllEventTypesService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  //States
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";

  const allEventTypesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.EVENT_TYPES,
      page,
      debouncedQuery,
      per_page,
      created_between,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.EVENT_TYPES,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          page: page,
          per_page: per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allEventTypesService },
    states: { searchQuery, setSearchQuery },
  };
};
